module.exports = __webpack_public_path__ + "static/media/bg_red.03912d83.jpg";